import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import { useRouter } from 'next/router';
import { Slices } from '@yoweb/prismic-slicemachine/components/Slices';
import { TargetedLandingPageTemplate } from '@yoweb/prismic-slicemachine/customtypes/PageTemplateTargetedLanding';
import { WaitlistForm } from '@store/components/Waitlist/WaitlistForm';
import { PAGE_PRICING } from '@store/constants/routes';
import { jsx as _jsx } from "react/jsx-runtime";

var TargetedLandingPage = function TargetedLandingPage(_ref) {
  var slices = _ref.slices,
      meta = _ref.meta,
      referralCode = _ref.referralCode;
  var router = useRouter();

  var submitWaitlistForm = function submitWaitlistForm(userInviteCode, firstName) {
    void router.push("".concat(PAGE_PRICING, "?success=true&inviteCode=").concat(userInviteCode, "&name=").concat(firstName));
  };

  return /*#__PURE__*/_jsx(Slices, {
    slices: slices,
    meta: meta,
    template: TargetedLandingPageTemplate,
    children: /*#__PURE__*/_jsx(WaitlistForm, {
      onComplete: submitWaitlistForm,
      referralCode: referralCode
    })
  });
};

TargetedLandingPage.layout = {
  type: 'marketing',
  props: {
    bgColor: 'base000'
  }
};
export var __N_SSP = true;
export default _withSuperJSONPage(TargetedLandingPage);